import { Grid, FormControlLabel, Switch, styled, Divider } from '@mui/material';
import { IJob } from 'wisestep-api';
import { WsColors, WsTypography } from 'wisestep-base';

import CardWrapper from '../../../../automatedEmailCampaignSettings/childRoutes/CardWrapper';
import { JobCard } from '../jobCard';

interface JobsListingProps {
  jobs: IJob[];
  selectedJobIds: Set<string>;
  onSelectOrDeselectJob: (jobIds: string[], opeartion: 'Select' | 'DeSelect') => void;
}

const SelectAllLabel = styled(FormControlLabel)(() => ({
  padding: 0,
  margin: 0,
  fontWeight: 900,
  fontSize: 14,
  '& .MuiFormControlLabel-label': {
    marginRight: 8,
  },
}));

const StyledSwitch = styled(Switch)(() => ({
  '& .MuiSwitch-track': {
    backgroundColor: WsColors.GreyText,
  },
  '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': {
    backgroundColor: WsColors.TheBlues500,
  },
}));

const JobsListing = ({ jobs, selectedJobIds, onSelectOrDeselectJob }: JobsListingProps) => {
  const onSelectAll = () =>
    onSelectOrDeselectJob(
      jobs.map((job) => job?.id ?? ''),
      jobs.length === selectedJobIds.size ? 'DeSelect' : 'Select'
    );

  return (
    <CardWrapper sx={{ p: 2 }}>
      <Grid container alignItems="center" justifyContent="space-between">
        <Grid item>
          <WsTypography bold>{`Similar Jobs (${jobs.length ?? 0})`}</WsTypography>
        </Grid>
        <Grid item>
          <SelectAllLabel
            control={
              <StyledSwitch
                size="medium"
                checked={selectedJobIds.size === jobs.length}
                onChange={onSelectAll}
              />
            }
            label="Select all"
            labelPlacement="start"
          />
        </Grid>
      </Grid>

      <Divider sx={{ my: 1 }} />

      <Grid container rowSpacing={1} width="100%">
        {jobs.map((job, index) => (
          <Grid item xs={12} key={index}>
            <JobCard
              lastUpdated={job.createdOn?.toString() ?? ''}
              title={job.title ?? ''}
              jobCode={job.jobCode ?? ''}
              onSelect={() => onSelectOrDeselectJob([job?.id ?? ''], 'Select')}
              onDeSelect={() => onSelectOrDeselectJob([job?.id ?? ''], 'DeSelect')}
              isSelected={selectedJobIds.has(job?.id ?? '')}
              updatedText="Last updated:"
            />
          </Grid>
        ))}
      </Grid>
    </CardWrapper>
  );
};

export default JobsListing;
